module.exports = __webpack_public_path__ + "img/attachment.34bc6c58.svg";